import { render, staticRenderFns } from "./ArchivedEventsTab.vue?vue&type=template&id=43c129c8&scoped=true&"
import script from "./ArchivedEventsTab.vue?vue&type=script&lang=js&"
export * from "./ArchivedEventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c129c8",
  null
  
)

export default component.exports